export const messages = {
  en: {
    register: {
      selectProvince: 'Select Province',
      selectCity: 'Select City',
      selectDistrict: 'Select District',
      shopNamePlaceholder: 'Please enter shop name',
      shopTypePlaceholder: 'Please select shop type',
      phonePlaceholder: 'Please enter phone number',
      passwordPlaceholder: 'Please enter password',
      smsCodePlaceholder: 'Please enter SMS code',
      getCodeBtn: 'Get Code',
      registerBtn: 'Register',
      hasAccount: 'Already have an account?',
      loginLink: 'Sign In'
    }
  },
  zh: {
    register: {
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectDistrict: '请选择区县',
      shopNamePlaceholder: '请输入商铺名称',
      shopTypePlaceholder: '请选择商铺类型',
      phonePlaceholder: '请输入手机号',
      passwordPlaceholder: '请输入密码',
      smsCodePlaceholder: '请输入短信验证码',
      getCodeBtn: '验证码',
      registerBtn: '注册',
      hasAccount: '已有账号？',
      loginLink: '立即登录'
    }
  }
}